export default __webpack_public_path__ + "static/PromptIconSix-bdab32bc0cf5519d72206793b0c6a7a8.png";